import React from 'react'
import { HashRouter as Router } from 'react-router-dom'
import { Layout } from 'antd'
import ContentPage from './Content'
import HeadMenu from './Header'

import styles from './layout.module.scss'

const LayoutPane: React.FC = () => {
  return (
    <div className={styles.layoutpane}>
      <Layout>
        <Router>
          <HeadMenu />
          <ContentPage />
        </Router>
      </Layout>
    </div>
  )
}

export default LayoutPane
